import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { ArrowLeft, Loader2 } from "lucide-react";
import AppShell from "../components/AppShell";
import { Logo } from "../components/Logo";
import { Field } from "./Login";
import PasswordField from "../components/PasswordField";
import { resetPassword } from "../lib/api";

export default function ResetPassword() {
  const loc = useLocation();
  const nav = useNavigate();
  const { phone, otp } = loc.state || {};
  const [password, setPassword] = useState("");
  const [confirm, setConfirm] = useState("");
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (!phone || !otp) nav("/forgot-password", { replace: true });
  }, [phone, otp, nav]);

  const submit = async (e) => {
    e.preventDefault();
    if (password.length < 8) return toast.error("Password must be at least 8 characters");
    if (password !== confirm) return toast.error("Passwords do not match");
    setLoading(true);
    try {
      await resetPassword({ phone, otp, new_password: password });
      toast.success("Password updated. Please sign in.");
      nav("/login", { replace: true });
    } catch (err) {
      toast.error(err?.response?.data?.detail || "Reset failed");
    } finally {
      setLoading(false);
    }
  };

  return (
    <AppShell>
      <div className="min-h-screen bg-white flex flex-col">
        <div className="screen flex-1 flex flex-col">
          <button
            onClick={() => nav(-1)}
            data-testid="reset-back-btn"
            className="w-10 h-10 rounded-full border border-neutral-200 flex items-center justify-center hover:bg-neutral-50"
          >
            <ArrowLeft className="w-4 h-4" />
          </button>
          <div className="mt-8 flex justify-center">
            <Logo size="md" />
          </div>
          <div className="mt-8 text-center">
            <h1 className="font-display font-bold text-[28px] tracking-tight text-black" data-testid="reset-title">
              Set new password
            </h1>
          </div>

          <form onSubmit={submit} className="mt-10 space-y-5">
            <Field label="New password">
              <PasswordField
                testId="reset-new-password-input"
                value={password}
                onChange={setPassword}
                placeholder="Minimum 8 characters"
                autoComplete="new-password"
                minLength={8}
              />
            </Field>

            <Field label="Confirm password">
              <PasswordField
                testId="reset-confirm-password-input"
                value={confirm}
                onChange={setConfirm}
                placeholder="Re-enter password"
                autoComplete="new-password"
              />
            </Field>

            <button
              type="submit"
              disabled={loading}
              data-testid="reset-submit-btn"
              className="btn-brand mx-auto h-11 flex items-center justify-center text-[14px] min-w-[220px]"
            >
              {loading ? <Loader2 className="w-5 h-5 animate-spin" /> : "Update password"}
            </button>
          </form>
        </div>
      </div>
    </AppShell>
  );
}
